export default {
    appLogin({}, payload) {
        localStorage.setItem('mb_token', payload)
    },
    appLogout() {
        localStorage.removeItem('mb_token')
    }
}